import axios from 'axios';

const apiClient = axios.create({
    baseURL: sessionStorage.getItem("baseUrl"),
    timeout: 300000, // 5 min secondes
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': "*"
    }
});

// Intercepteur de requête pour ajouter des headers
apiClient.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem("token");
        if (token) {
            // Ajouter les headers ici
            config.headers['Authorization'] = `Bearer ${token}`;
            config.headers['Content-Type'] = 'application/json';
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Intercepteur de réponse pour gérer les erreurs
apiClient.interceptors.response.use(
    response => response,
    error => {
        // Vérifier si l'erreur est due à un timeout
        if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
            console.log('La requête a expiré (timeout)');
            // Vous pouvez personnaliser le message d'erreur ou les actions ici
        }
        return Promise.reject(error);
    }
);

export default apiClient;